import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '51吃瓜域名 - 官方入口地址导航',
          description: '51吃瓜域名是访问51吃瓜平台的核心入口，汇总最新域名、备用域名及防失联跳转方案。',
          url: 'https://51chigua.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '51吃瓜',
            url: 'https://51chigua.com',
          },
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <TrendingSection />
          <CategoryGrid />
          <LatestArticles />
          <section className="w-full bg-background-100 px-4 md:px-6 lg:px-8 py-12 md:py-16">
            <div className="max-w-6xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                收藏本站，永不迷路
              </h2>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed mb-6">
                将本页加入浏览器收藏夹（Ctrl+D / Cmd+D），随时获取51吃瓜最新域名和备用入口。无论域名如何变更，这里永远是最可靠的入口导航。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <button
                  className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg text-sm font-bold transition-colors cursor-pointer"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  <i className="ri-bookmark-line mr-2"></i>
                  收藏本页
                </button>
                <button
                  className="whitespace-nowrap bg-background-50 hover:bg-background-200 text-foreground-700 px-6 py-3 rounded-lg text-sm font-medium border border-background-300/60 transition-colors cursor-pointer"
                  onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}
                >
                  <i className="ri-information-line mr-2"></i>
                  了解更多
                </button>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}